import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;
`;

const Content = styled.div`
  font-family: ${props => props.theme.fontFamilyBody};
  font-size: 21px;
  line-height: 130%;

  a {
    font-weight: ${props => props.theme.fontWeightBold};

    &:hover {
      cursor: pointer;
      text-decoration: none;
    }

    &.show-less {
      display: block;
    }
  }
`;

export default function Summary({ summary }) {
  const initialLength = 350;
  const summaryNeedTruncate = summary.length > initialLength;
  const [showMore, setShowMore] = React.useState(summaryNeedTruncate);
  const summaryToShow = showMore ? _.truncate(summary, {
    length: initialLength,
    separator: /,? +/,
    omission: ' ... ',
  }) : summary;

  const toggleShowMore = e => {
    e && e.preventDefault();

    setShowMore(!showMore);
  };

  return (
    <Container>
      <Content>
        {summaryToShow}
        {showMore && <a href="#" onClick={toggleShowMore}>More</a>}
        {summaryNeedTruncate && !showMore && <a href="#" className="show-less" onClick={toggleShowMore}>Less</a>}
      </Content>
    </Container>
  );
}

Summary.propTypes = {
  summary: PropTypes.string.isRequired,
};
